module.exports = __webpack_public_path__ + "static/media/SDFSA_6-317w.5f56c23b.jpg";